// extracted by mini-css-extract-plugin
export default {"categoriesWrapper":"Home_categoriesWrapper__tcnEi"};